// extracted by mini-css-extract-plugin
export default {"contactForm":"contactForm_contactForm__X0oih"};